import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../siteConfig.js";
import logo from "../assets/logo.png";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footerGrid">

          <div className="footerBrand">
            <img src={logo} alt={`${siteConfig.appName} logo`} className="footerLogo" />
            <div className="footerBrandName">{siteConfig.appName}</div>
            <div className="footerBrandTagline">
              {siteConfig.appTagline}<br />
              A {siteConfig.companyLegalName} product — Nairobi, Kenya.
            </div>
            <a
              href={siteConfig.playStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex", alignItems: "center", gap: "8px",
                marginTop: "4px", background: "rgba(255,255,255,0.07)",
                border: "1px solid rgba(255,255,255,0.12)", borderRadius: "10px",
                padding: "10px 16px", color: "#fff", textDecoration: "none",
                fontSize: "13px", fontWeight: "700", width: "fit-content",
              }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3.18 23.76c.3.17.64.24.99.19L14.9 12 3.18.05A1.5 1.5 0 0 0 3 .72v22.56c0 .19.06.36.18.48z"/>
                <path d="M19.35 9.29 16.3 7.54 12.83 12l3.47 4.46 3.05-1.75A2 2 0 0 0 20.5 12a2 2 0 0 0-1.15-2.71z"/>
              </svg>
              Download on Google Play
            </a>
          </div>

          <div>
            <div className="footerColTitle">The App</div>
            <div className="footerLinks">
              <Link to="/our-app" className="footerLink">About Rahisi</Link>
              <a href={siteConfig.playStoreUrl} target="_blank" rel="noopener noreferrer" className="footerLink">Download</a>
              <Link to="/business-functions" className="footerLink">Features</Link>
            </div>
          </div>

          <div>
            <div className="footerColTitle">Company</div>
            <div className="footerLinks">
              <Link to="/about" className="footerLink">About Mtaani</Link>
              <Link to="/governance" className="footerLink">Governance</Link>
              <Link to="/contact" className="footerLink">Contact Us</Link>
            </div>
          </div>

          <div>
            <div className="footerColTitle">Legal</div>
            <div className="footerLinks">
              <Link to="/privacy" className="footerLink">Privacy Policy</Link>
              <Link to="/terms" className="footerLink">Terms & Conditions</Link>
            </div>
            <div className="footerColTitle" style={{ marginTop: "28px" }}>Support</div>
            <a href={`mailto:${siteConfig.supportEmail}`} className="footerEmailLink">
              {siteConfig.supportEmail}
            </a>
          </div>

        </div>

        <div className="footerBottom">
          <div className="footerCopy">
            © {new Date().getFullYear()} {siteConfig.companyLegalName}. All rights reserved.
          </div>
          <div className="footerBottomLinks">
            <Link to="/privacy" className="footerBottomLink">Privacy</Link>
            <Link to="/terms" className="footerBottomLink">Terms</Link>
            <Link to="/contact" className="footerBottomLink">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
